import { Link } from "react-router-dom";
import SEO, { pageSEO } from "../components/SEO";

export default function TermsOfServicePage() {
  return (
    <div data-testid="terms-of-service-page">
      <SEO {...pageSEO.termsOfService} />
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-[#243b5a]">
        <div className="container-max px-6 md:px-12 lg:px-24 text-center text-white">
          <h1 className="font-serif text-4xl md:text-5xl mb-4">Terms of Service</h1>
          <p className="text-white/70">Last updated: December 2025</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding bg-white">
        <div className="container-max max-w-4xl">
          <div className="prose prose-lg max-w-none text-[#4A4A4A]">
            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Agreement to Terms</h2>
            <p>
              By accessing or using the Awaken India Tours website and services, you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Services Description</h2>
            <p>
              Awaken India Tours provides luxury small-group travel experiences to India. Our services include trip planning, 
              accommodations, transportation, guided tours, and related travel services as described on our website.
            </p>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Booking and Payment</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Reservations:</strong> All bookings are subject to availability and confirmation.</li>
              <li><strong>Deposits:</strong> A non-refundable deposit may be required to secure your reservation.</li>
              <li><strong>Final Payment:</strong> Full payment is due according to the schedule provided at the time of booking.</li>
              <li><strong>Pricing:</strong> All prices are subject to change until booking is confirmed. Prices are quoted in US dollars.</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Cancellation Policy</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Cancellations made 45+ days before departure: Full refund</li>
              <li>Cancellations made 15-44 days before departure: 50% refund</li>
              <li>Cancellations made less than 15 days before departure: No refund</li>
            </ul>
            <p className="mt-4">
              We strongly recommend purchasing travel insurance to protect your investment.
            </p>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Traveler Responsibilities</h2>
            <p>As a traveler, you are responsible for:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Ensuring you have a valid passport with at least 6 months validity</li>
              <li>Obtaining necessary visas and travel documents</li>
              <li>Ensuring you are fit to travel and disclosing any health conditions</li>
              <li>Having appropriate travel and medical insurance</li>
              <li>Complying with local laws and customs</li>
              <li>Arriving at designated meeting points on time</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Limitation of Liability</h2>
            <p>
              Awaken India Tours acts as an agent for various service providers including hotels, transportation companies, and tour operators. 
              We are not liable for:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Acts, omissions, or defaults of third-party service providers</li>
              <li>Injury, death, property damage, or other losses arising from circumstances beyond our control</li>
              <li>Flight delays, cancellations, or changes by airlines</li>
              <li>Weather conditions, natural disasters, or political instability</li>
              <li>Personal injury or illness during travel</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Changes to Itinerary</h2>
            <p>
              We reserve the right to modify the itinerary due to unforeseen circumstances, safety concerns, or factors beyond our control. 
              We will make reasonable efforts to provide comparable alternatives.
            </p>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Intellectual Property</h2>
            <p>
              All content on this website, including text, images, logos, and design, is the property of Awaken India Tours and is 
              protected by copyright and trademark laws. Unauthorized use is prohibited.
            </p>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Governing Law</h2>
            <p>
              These Terms of Service are governed by the laws of the United States and the State of Massachusetts. 
              Any disputes shall be resolved in the courts of Massachusetts.
            </p>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to our website. 
              Continued use of our services constitutes acceptance of the modified terms.
            </p>

            <h2 className="font-serif text-2xl text-[#243b5a] mt-8 mb-4">Contact Us</h2>
            <p>
              If you have questions about these Terms of Service, please contact us at:
            </p>
            <p className="mt-2">
              <strong>Email:</strong> <a href="mailto:aaron@awakenindiatours.com" className="text-[#D4AF37] hover:underline">aaron@awakenindiatours.com</a><br />
              <strong>Phone:</strong> <a href="tel:781-367-4010" className="text-[#D4AF37] hover:underline">781-367-4010</a>
            </p>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <Link to="/" className="text-[#243b5a] hover:text-[#D4AF37] transition-colors font-medium">
              &larr; Back to Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
